import { DateValidationError } from "@mui/x-date-pickers/models"
import { Dayjs } from "dayjs"

/**
 * Maps MUI X DatePicker validation error to user-friendly error message
 */
export const getDatePickerErrorMessage = (
  error: DateValidationError | null,
  type: "start" | "end",
  value: Dayjs | null,
  startDate?: Dayjs | null,
  endDate?: Dayjs | null,
  minDate?: Dayjs | null,
  maxDate?: Dayjs | null
): string => {
  if (!error) return ""

  switch (error) {
    case "invalidDate":
      return "Invalid date format. Please use the format MM/DD/YYYY"
    case "minDate":
      if (minDate) {
        return `Date cannot be earlier than ${minDate.format("MM/DD/YYYY")}`
      }
      return "Date is too early"
    case "maxDate":
      if (maxDate) {
        return `Date cannot be later than ${maxDate.format("MM/DD/YYYY")}`
      }
      return "Date is too late"
    case "disableFuture":
      return "Future dates are not allowed"
    case "disablePast":
      return "Past dates are not allowed"
    case "shouldDisableDate":
      return "This date is not available"
    default:
      // Custom validation for date range
      if (value && type === "end" && startDate && !value.isAfter(startDate)) {
        return "The end date cannot be earlier than the start date"
      }
      if (value && type === "start" && endDate && value.isAfter(endDate)) {
        return "The start date cannot be later than the end date"
      }
      return "Invalid date format. Please use the format MM/DD/YYYY"
  }
}
